import { render, staticRenderFns } from "./SysManagement.vue?vue&type=template&id=a89e7eb8&"
import script from "./SysManagement.vue?vue&type=script&lang=js&"
export * from "./SysManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports